import { render, staticRenderFns } from "./RequisitionDocuments.vue?vue&type=template&id=46bc6363&scoped=true"
import script from "./RequisitionDocuments.vue?vue&type=script&lang=js"
export * from "./RequisitionDocuments.vue?vue&type=script&lang=js"
import style0 from "./RequisitionDocuments.vue?vue&type=style&index=0&id=46bc6363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bc6363",
  null
  
)

export default component.exports